<script setup lang="ts">
import merge from 'lodash-es/merge';

import type { ListItemModel as SectionListItemModel } from '#layers/prawopl/app/pages/cms/modules/wk-sections/_runtime/services/SectionsService';
import SectionsService from '#layers/prawopl/app/pages/cms/modules/wk-sections/_runtime/services/SectionsService';

defineOptions({
    name: 'WkSectionsNewsSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    sectionId: null
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            sectionId: schema.number().nullable()
                .required($t('[[[Wybieranie sekcji jest wymagane]]]'))
                .typeError($t('[[[Wybieranie sekcji jest wymagane]]]'))
        })
    }));
}

async function fetchSection(id: number): Promise<SectionListItemModel>
{
    const response = await SectionsService.fetchAutocomplete(id);

    return response || null;
}

async function searchSection(query: string, limit: number): Promise<SectionListItemModel[]>
{
    return await SectionsService.getAutocomplete(query, limit);
}
onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Wybierz sekcje]]]')">
        <IdeoAutocomplete
            v-model="form.settings.sectionId"
            name="sectionId"
            track-by="id"
            :placeholder="$t('[[[Wyszukaj sekcję...]]]')"
            :default-label="$t('[[[Brak sekcji]]]')"
            :fetch="(id: number) => fetchSection(id)"
            :search="(query: string, limit: number) => searchSection(query, limit)"
        >
            <template #selected="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
            <template #option="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
        </IdeoAutocomplete>
    </IdeoFormGroup>
</template>
